'use client';

import type { RefObject } from 'react';
import { useLayoutEffect } from '@react-aria/utils';
import type { KeyboardDelegate } from '@react-types/shared';
import type { ListFilterState } from '../List/types';

type Props = {
  disallowEmptySelection: boolean;
  keyboardDelegate: KeyboardDelegate;
};

/**
 * Helper hook to scroll to the first item in the list when
 * 1) the loading state changes from true to false
 * 2) the query changes in a client-side filtered list
 */

export function useScrollToFirstItem<T>(
  props: Props,
  state: ListFilterState<T>,
  ref: RefObject<HTMLElement | null>
) {
  function selectFirstItem() {
    // @ts-expect-error FIXME(strictNullChecks)
    ref.current.scrollTo({ top: 0 });
    // @ts-expect-error FIXME(strictNullChecks)
    const key = props.keyboardDelegate.getFirstKey();
    if (!key) return;
    state.selectionManager.setFocusedKey(key);
    if (
      state.selectionManager.selectionMode === 'single' &&
      state.selectionManager.selectionBehavior === 'replace' &&
      props.disallowEmptySelection
    ) {
      state.selectionManager.replaceSelection(key);
    }
  }

  /**
   * Select on query change
   */

  useLayoutEffect(() => {
    if (!state.isAsync && state.queryState.hasQueryChanged) {
      // eslint-disable-next-line no-param-reassign
      state.queryState.hasQueryChanged = false;
      selectFirstItem();
    }
  });
}
